module.exports = __webpack_public_path__ + "img/logo.c3d3905c.png";